import * as React from 'react';
import { IUser } from '../components/pages/Profile/api';
import { InitUser } from './UserContext';

export default function useUser() {
    const { useState, useCallback } = React;
    const [user, setUserState] = useState<IUser>(InitUser);

    const setUser = useCallback((newUser: IUser) => {
        setUserState(newUser);
    }, []);

    return {
        user,
        setUser,
    }
}